import styled from "@emotion/styled";
import { Loading } from "./components";

export const FullHeightLoading = styled(Loading)`
  height: 100vh;
`;
